import DOMPurify from 'dompurify';

export const replaceLinebreaks = (text: string) => {
  return DOMPurify.sanitize(text.replace(/\n/g, '<br>'));
};
